<template>
  <v-container class="px-8">
    <div class="py-3 pl-2 flex-grow-0 flex-shrink-0">
      <div class="d-flex flex-row justify-space-between align-end">
        <div class="text-h4 font-weight-medium">
          {{ $t("navbar.menu.surveys") }}
        </div>
        <NewSurveyDialog :key="dialogKey" @closed="dialogKey++" />
      </div>
    </div>
    <v-card>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">{{ $t("common.name") }}</th>
                <th class="text-center">{{ $t("surveys.NewSurveyDialog.questions") }}</th>
                <th class="text-left">{{ $t("common.dueDate") }}</th>
                <th class="text-left">{{ $t("common.reminder") }}</th>
                <th class="text-left">{{ $t("surveys.surveys.results") }}</th>
                <th class="text-left">{{ $t("surveys.surveys.options") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="survey in surveys" :key="survey.id">
                <td class="text-subtitle-2">{{ survey.name }}</td>
                <td class="text-center">{{ survey.questions }}</td>
                <td>{{ survey.date | zonedDate("Pp", "UTC") }}</td>
                <td>
                  <v-icon v-if="survey.reminder">mdi-check</v-icon>
                </td>
                <td>
                  <v-btn v-if="survey.hasResults" icon @click="viewResults(survey.id)">
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-btn icon>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-dots-vertical</v-icon>
                      </template>
                      <v-list>
                        <v-list-item v-if="survey.hasResults" @click="viewResults(survey.id)">
                          <v-list-item-icon>
                            <v-icon>mdi-playlist-check</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              >{{ $t("surveys.surveys.viewResults") }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-else @click="editSurvey(survey.id)">
                          <v-list-item-icon>
                            <v-icon>mdi-pencil</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>{{ $t("common.edit") }} </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="deleteSurvey(survey)">
                          <v-list-item-icon>
                            <v-icon>mdi-delete</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>{{ $t("common.delete") }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <SurveyReview :surveyId="surveyDialogId" @closed="surveyDialogId = null"></SurveyReview>
    <v-dialog v-model="deleteSurveyDialog" width="400">
      <v-card v-if="deletingSurvey">
        <v-card-title class="headline primary white--text">{{
          $t("surveys.surveys.delete")
        }}</v-card-title>

        <v-card-text>
          <span class="text-subtitle-1">{{ $t("surveys.surveys.deleteQ") }}</span>
          <span class="text-subtitle-2">{{ deletingSurvey.name }}?</span>
          <br />{{ $t("common.notUndone") }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteSurveyDialog = false">{{
            $t("common.cancel")
          }}</v-btn>
          <v-btn color="primary" @click="confirmDelete(deletingSurvey.id)">{{
            $t("common.delete")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <NewSurveyDialog :edit="true" :oldSurvey="oldSurvey" @closed="oldSurvey = null" />
  </v-container>
</template>

<script>
import firestore from "@/firebase/firestore";
import NewSurveyDialog from "./NewSurveyDialog";
import SurveyReview from "./SurveyReview";

export default {
  components: { NewSurveyDialog, SurveyReview },
  data: () => ({
    dialogKey: 0,
    surveyDialogId: null,
    deleteSurveyDialog: null,
    deletingSurvey: null,
    oldSurvey: null,
  }),
  computed: {
    surveys() {
      const surveys = Object.values(this.$store.state.trip.surveys);
      return surveys
        .sort((a, b) => a.date.seconds - b.date.seconds)
        .map((s) => ({
          id: s.id,
          name: s.name,
          questions: s.questions.length,
          hasResults: Object.keys(s.responses || {}).length > 0,
          reminder: s.alarm,
          date: s.date, // | this.$options.filters.zonedDate("Pp", "UTC"),
        }));
    },
  },
  methods: {
    viewResults(surveyId) {
      this.surveyDialogId = surveyId;
    },
    editSurvey(surveyId) {
      this.oldSurvey = this.$store.state.trip.surveys[surveyId];
    },
    deleteSurvey(survey) {
      this.deleteSurveyDialog = true;
      this.deletingSurvey = survey;
    },
    confirmDelete(surveyId) {
      this.deletingSurvey = null;
      this.deleteSurveyDialog = false;
      console.log("deleting survey with id ", surveyId);
      firestore.writeTrackedDocument(
        this.$store.getters.currentTripId,
        "surveys",
        {},
        surveyId,
        true,
      );
    },
  },
};
</script>
